import React, { useState, useEffect } from 'react';
import { useSelector, useDispatch } from 'react-redux';

import {
  ClickAwayListener,
  Grid,
  Typography,
  Divider,
} from '@material-ui/core';

import { ReactComponent as OpenNavDrop } from '../../images/openDropdownNav.svg';
import { ReactComponent as CloseNavDrop } from '../../images/closeDropdownNav.svg';
// import GamificationPopup from '../../components/Gamification/GamificationPopup';
import AttendancePopup from '../../components/AttendancePopup';
import { getUser } from '../../actions/users/co-user-actions';
import { checkInSubscription } from '../../components/Utils/helper';

export default function UserDropdown({ tokenData, classes }) {
  const [openAttendancePopup, setOpenAttendancePopup] = useState(false);
  // const [tutorial, setTutorial] = useState(false);
  const [dropdownOpen, setDropDown] = useState(false);

  const dispatch = useDispatch();
  const userData = useSelector((state) => state.coUser?.userData);

  // open attendance popup if force clockIn is true
  useEffect(() => {
    if (
      userData?.roleId !== 4 &&
      userData?.showShiftTimings &&
      userData?.forceClockIn &&
      (!userData?.attendance ||
        userData?.attendance?.length === 0 ||
        userData?.attendance?.[0]?.status === 'checkOut')
    ) {
      setOpenAttendancePopup(true);
      dispatch(getUser());
    }
  }, [userData?.forceClockIn]);

  const handleLogout = () => {
    localStorage.clear();
    window.location.href = '/signin';
  };

  const handleOpenAttendancePopup = () => {
    setOpenAttendancePopup(true);
    dispatch(getUser());
  };
  return (
    <div>
      <ClickAwayListener
        onClickAway={() => {
          setDropDown(false);
        }}
      >
        <div>
          {dropdownOpen ? (
            <OpenNavDrop
              className={classes.cursor__pointer}
              onClick={() => {
                setDropDown(!dropdownOpen);
              }}
            />
          ) : (
            <CloseNavDrop
              className={classes.cursor__pointer}
              onClick={() => {
                setDropDown(!dropdownOpen);
              }}
            />
          )}
          {dropdownOpen && (
            <Grid className={classes.root__dropdown__main} conatiner>
              {checkInSubscription('clockIn') &&
                tokenData?.roleId !== 4 &&
                userData?.showShiftTimings && (
                  <>
                    <Typography
                      className={classes.dropdown__menu__text}
                      onClick={handleOpenAttendancePopup}
                    >
                      <span className={classes.dropdown__menu__text}>
                        Clock In/Clock Out
                      </span>
                    </Typography>
                    <Divider />
                  </>
                )}
              {/* {tokenData?.roleId === 4 && tokenData?.coUserId === 1 && (
                <>
                  <Typography
                    className={classes.dropdown__menu__text}
                    onClick={() => setTutorial(true)}
                  >
                    <span className={classes.dropdown__menu__text}>
                      Tutorials
                    </span>
                  </Typography>
                  <Divider />
                </>
              )} */}

              <Typography
                className={classes.dropdown__menu__text}
                onClick={handleLogout}
              >
                Sign Out
              </Typography>
            </Grid>
          )}
        </div>
      </ClickAwayListener>
      {openAttendancePopup && (
        <AttendancePopup
          toggle={openAttendancePopup}
          setToggle={setOpenAttendancePopup}
        />
      )}
      {/* {tutorial && (
        <GamificationPopup toggle={tutorial} setToggle={setTutorial} />
      )} */}
    </div>
  );
}
